<div class="forms-container">
    @if(!isSelfOrder() && activePage !== 'Forgot Password' && activePage !== "Guest Checkout"){
        <cwo-button-group [buttonGroupName]="'buttonGroup'" [parentExpanded]="parentExpanded()" [(ngModel)]="activePage" (ngModelChange)="onActivePageChange($event)" [optionValues]="['Sign In', 'Sign Up']" />
    }
    @switch (activePage) {
        @case ('Sign In') {
            <div class="form-container" [ngStyle]="{'padding': '1.5rem 1rem 1.25rem'}">
                <cwo-login-form 
                    #loginFormComp
                    [hideGuestButton]="hideGuestButton()"
                    (forgotPasswordClicked)="forgotPasswordClicked($event)" 
                    (guestCheckoutClicked)="guestCheckoutClicked($event)" 
                    (personalDetailsCompleted)="personalDetailsCompleted.emit('login')"
                    [showTableNumberInput]="showTableNumberInput()"
                    [showTableNumberText]="showTableNumberText()"
                    [tableNumber]="tableNumber()"
                    [showTableNumberError]="showTableNumberError()"
                    (tableNumberChange)="tableNumberChange.emit($event)"
                    (tableNumberBlur)="tableNumberBlur.emit()"
                    [hasNewCreditCard]="hasNewCreditCard()" />
            </div>
        }
        @case ('Sign Up') {
            <div class="form-container" [ngStyle]="{'padding': 0}">
                <cwo-register-form [submitButton]="submitButton()" #registerFormComp [boxShadow]="boxShadow()" (personalDetailsCompleted)="personalDetailsCompleted.emit('register')"/>
            </div>
        }
        @case ('Forgot Password') {
            <div class="form-container" [ngStyle]="{'padding': '0 1rem 1rem'}">
                <cwo-forgot-password-form (backToSignInClicked)="backToSignIn()"  />
            </div>
        }
        @case ('Guest Checkout') {
            <div class="form-container" [ngStyle]="{'padding': '0.25rem 1rem 1.25rem'}">
                <cwo-guest-checkout-form
                    #guestFormComp
                    [showTableNumberInput]="showTableNumberInput()"
                    [showTableNumberText]="showTableNumberText()"
                    [tableNumber]="tableNumber()"
                    [showTableNumberError]="showTableNumberError()"
                    (backToSignInClicked)="backToSignIn()"
                    (personalDetailsCompleted)="personalDetailsCompleted.emit('guest')"
                    (tableNumberChange)="tableNumberChange.emit($event)"
                    (tableNumberBlur)="tableNumberBlur.emit()"
                />
            </div>
        }
    }
</div>